import { Check } from "lucide-react";
import Image from "next/image";

type AnalysisCardProps = {
  copy: {
    title: string;
    items: readonly string[];
    readyLabel: string;
  };
  compact?: boolean;
  className?: string;
};

export function AnalysisCard({ copy, compact = false, className = "" }: AnalysisCardProps) {
  return (
    <article
      className={`relative z-10 min-w-0 rounded-[22px] border border-green-100 bg-green-50/70 text-center shadow-[0_24px_70px_-48px_rgba(8,166,47,0.75)] ring-1 ring-white/70 ${compact ? "px-4 py-5" : "px-7 py-8"} ${className}`}
    >
      <div className={`mx-auto flex items-center justify-center rounded-full bg-green-100 text-[#08A62F] ${compact ? "h-14 w-14" : "h-20 w-20"}`}>
        <Image width={20} height={20} alt="Sparkes" src="/images/icons/stars.png" className={compact ? "h-7 w-7 fill-current" : "h-10 w-10 fill-current"} />
      </div>

      <h3 className={`${compact ? "mt-3 text-base" : "mt-5 text-lg"} font-black text-slate-950`}>{copy.title}</h3>

      <ul className={`mx-auto max-w-[220px] text-left ${compact ? "mt-4 space-y-2" : "mt-5 space-y-3"}`}>
        {copy.items.map((item) => (
          <li key={item} className="flex items-center gap-2 text-xs font-medium text-slate-800 sm:text-sm">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-100 text-[#08A62F]">
              <Check className="h-3.5 w-3.5" strokeWidth={3} aria-hidden />
            </span>
            <span>{item}</span>
          </li>
        ))}
      </ul>

      <p className={`${compact ? "mt-4" : "mt-7"} text-sm font-black text-[#08A62F]`}>{copy.readyLabel}</p>
    </article>
  );
}
